import XeroAuthButtonIcon from './XeroAuthButtonIcon';

export default XeroAuthButtonIcon;
